<template>
  <ankh-list :show-search-form="false" :show-btn-group="false" v-bind="$attrs">
    <template #table="{height}">
      <table-list ref="list"
                  :height="height"
                  @query="loadList"
                  @selection-change="selection = $event"
                  :data="tableData">
        <el-table-column align="center" :label="$t('标题')" prop="name" />
        <el-table-column align="center" :label="$t('更新时间')">
          <template v-slot="{row}">
            {{row.updateTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('操作')">
          <template v-slot="{row}">
            <el-button type="primary" size="mini" @click="$router.push('/rice-tip/list?code=' + row.code)">{{$t('编辑')}}</el-button>
          </template>
        </el-table-column>
      </table-list>
    </template>
  </ankh-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
import AnkhList from "@/components/list/AnkhList.vue";
export default {
  name: "RiceScore",
  components: {AnkhList, TableList},
  data() {
    return {
      tableData: [],
      selection: []
    }
  },
  methods: {
    async loadList(params, setTotal) {
      try {
        const res = await request(this.$api.riceRwrTips.list, params);
        this.tableData = res.riceRwrTipss;
        setTotal(res.pager.itemCount);
      } catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<style scoped>

</style>
